import { render, staticRenderFns } from "./ProgramPage.vue?vue&type=template&id=0acc77ce&scoped=true&"
import script from "./ProgramPage.vue?vue&type=script&lang=js&"
export * from "./ProgramPage.vue?vue&type=script&lang=js&"
import style0 from "./ProgramPage.vue?vue&type=style&index=0&id=0acc77ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acc77ce",
  null
  
)

export default component.exports